/*
  <ia-ritual-add> — the "add full ritual" button in IA Complete Experience.
  Adds every step card's selected variant in one /cart/add.js call and keeps the
  button's total in sync with the card pickers.
*/
import { formatPrice, openCart } from 'ia-util-helpers'

class IaRitualAdd extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-ritual-add]')
    if (!this.button) return

    this.abortController = new AbortController()
    const { signal } = this.abortController
    this.totalEl = this.querySelector('[data-ritual-total]')

    this.button.addEventListener('click', this.handleClick.bind(this), { signal })
    // Card selects live inside this element, so their change events bubble here.
    this.addEventListener('change', this.renderTotal.bind(this), { signal })
    this.renderTotal()
  }

  disconnectedCallback() {
    this.abortController?.abort()
  }

  // One line per step card, skipping unavailable picks — a sold-out id would
  // fail the whole add.
  get lines() {
    return [...this.querySelectorAll('ia-product-card')]
      .map((card) => {
        const option = card.querySelector('[data-card-variant-select]')?.selectedOptions[0]
        if (option?.disabled) return null
        const id = option?.value || card.querySelector('form [name="id"]')?.value
        return id ? { id: Number(id), quantity: 1, price: Number(option?.dataset.variantPriceRaw) || 0 } : null
      })
      .filter(Boolean)
  }

  renderTotal() {
    if (!this.totalEl) return
    const total = this.lines.reduce((sum, line) => sum + line.price, 0)
    this.totalEl.textContent = total ? formatPrice(total) : ''
    this.totalEl.hidden = !this.totalEl.textContent
  }

  setBusy(busy) {
    this.busy = busy
    this.button.disabled = busy
    this.button.classList.toggle('adding', busy)
  }

  async handleClick() {
    if (this.busy) return
    const items = this.lines.map(({ id, quantity }) => ({ id, quantity }))
    if (!items.length) return

    this.setBusy(true)
    // addToCartJson traps fetch errors internally and resolves null.
    const cart = await window.iaCartAPI?.addToCartJson({ items })
    this.setBusy(false)
    if (cart) openCart()
  }
}

if (!customElements.get('ia-ritual-add')) {
  customElements.define('ia-ritual-add', IaRitualAdd)
}
